import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { FileRecordNew } from '../types/file-record';

export type UpdateFileRecordsRequest = {
    id: string;
    fields: Partial<Omit<FileRecordNew, 'parentFolderId' | 'type'>> & { parentFolderId?: string; mimeType?: string };
    updateReferences?: boolean;
}[];

async function updateFileRecords(request: UpdateFileRecordsRequest): Promise<void> {
    await api.patch('/file-records', request);
}

export function useUpdateFileRecords(): UseMutationResult<void, AxiosError, UpdateFileRecordsRequest, unknown> {
    return useMutation(updateFileRecords, {
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
        },
    });
}
